import { MOST_ENGAGED } from "constants/actionTypes";
import { IArticlesItem } from "../interfaces";
import * as interfaces from "../interfaces";

const mostEngagedInitialState = {
  loading: false,
  data: Array<IArticlesItem>(),
  page: 0,
};

export const mostEngagedReducer = (state = mostEngagedInitialState, action: interfaces.IArticlesAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case MOST_ENGAGED.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.data = [...state.data, ...action.payload];
      new_state.page += 1;
      return new_state;
    case MOST_ENGAGED.LOAD:
      new_state.loading = true;
      return new_state;
    case MOST_ENGAGED.LOAD_FAIL:
      new_state.loading = false;
      return new_state;
    case MOST_ENGAGED.ADD_FAVOURITE:
      new_state.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = true;
        }
        return item;
      });
      return new_state;

    case MOST_ENGAGED.ADD_CURATE:
      new_state.data = state.data.filter((item) => {
        if (item.id === action.curate_article_id) {
          item.is_curated = true;
        }
        return item;
      });
      return new_state;

    case MOST_ENGAGED.REMOVE_FAVOURITE:
      new_state.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = false;
        }
        return item;
      });
      return new_state;

    case MOST_ENGAGED.REMOVE_CURATE:
      new_state.data = state.data.filter((item) => {
        if (item.id === action.curate_article_id) {
          item.is_curated = false;
        }
        return item;
      });
      return new_state;

    case MOST_ENGAGED.REMOVE_ALL_CURATE:
      new_state.data = state.data.map((item) => {
        if (item.is_curated) {
          item.is_curated = false;
        }
        return item;
      });
      return new_state;

    default:
      return state;
  }
};
